import { Tabs } from "antd";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ProductBrands from "../../components/settings/TabsServices/ProductBrands";
import ProductCategories from "../../components/settings/TabsServices/ProductCategories";
import Suppliers from "../../components/settings/TabsServices/Suppliers";
const Services = (props: any) => {
  const intl = useIntl();
  const { locale } = useIntl();

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <div className="min-w-[150px] justify-center flex items-center gap-2 w-full px-2 py-1">
    //       {intl.formatMessage({ id: "inventoryTabLabel" })}
    //     </div>
    //   ),
    //   children: <Stocktaking />,
    // },
    // {
    //   key: "2",
    //   label: (
    //     <div className="min-w-[150px] justify-center flex items-center gap-2 w-full px-2 py-1">
    //       {intl.formatMessage({ id: "supplyRequestsTabLabel" })}
    //     </div>
    //   ),
    //   children: <SupplyRequests />,
    // },
    {
      key: "3",
      label: (
        <div className="min-w-[150px] justify-center flex items-center gap-2 w-full px-2 py-1">
          {intl.formatMessage({ id: "suppliersTabLabel" })}
        </div>
      ),
      children: <Suppliers />,
    },

    {
      key: "4",
      label: (
        <div className="min-w-[150px] justify-center flex items-center gap-2 w-full px-2 py-1">
          {intl.formatMessage({ id: "productCategories" })}
        </div>
      ),
      children: <ProductCategories />,
    },
    {
      key: "5",
      label: (
        <div className="min-w-[150px] justify-center flex items-center gap-2 w-full px-2 py-1">
          {intl.formatMessage({ id: "productBrands" })}
        </div>
      ),
      children: <ProductBrands />,
    },
  ];
  const onChange = (key: string) => {
    console.log(key);
  };
  return (
    <div>
      <div className="flex items-center gap-2 text-2xl font-semibold leading-7 text-color-primary text-end">
        <span className="">
          {intl.formatMessage({ id: "salonSettingsTitle" })}
        </span>
      </div>
      <div className="my-4 text-base font-normal leading-7 text-color-gray ">
        {intl.formatMessage({ id: "salonSettingsSubtitle" })}
      </div>
      <div className="flex items-center gap-4 text-center max-lg:grid max-lg:grid-cols-2">
        <Link
          to="/catalog"
          className="flex items-center gap-1 w-fit rounded-lg text-center bg-[#EEF0FF] p-2"
        >
          <span>{intl.formatMessage({ id: "servicesLinkText" })}</span>
          {locale === "ar" ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </Link>
        <Link
          to="/catalog"
          className="flex items-center gap-1 w-fit rounded-lg text-center bg-[#EEF0FF] p-2"
        >
          <span>{intl.formatMessage({ id: "productsLinkText" })}</span>
          {locale === "ar" ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </Link>
        <Link
          to="/catalog"
          className="flex items-center gap-1 w-fit rounded-lg text-center bg-[#EEF0FF] p-2"
        >
          <span>{intl.formatMessage({ id: "membershipsLinkText" })}</span>
          {locale === "ar" ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </Link>
        <Link
          to="/catalog"
          className="flex items-center gap-1 w-fit rounded-lg text-center bg-[#EEF0FF] p-2"
        >
          <span>{intl.formatMessage({ id: "giftCardsLinkText" })}</span>
          {locale === "ar" ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </Link>
      </div>
      <div className="mt-10 tabs-card-wrapper ">
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarStyle={{ margin: 0 }}
        />
      </div>
    </div>
  );
};

export default Services;
